import { useState } from "react";
import Sidebar from "../../../sidebar/sidebar";
import Header from "../../../header/header";

/**
 * Placeholder home page for the supplier instance.
 *
 * Renders the standard Sidebar + Header chrome with a centered
 * "Supplier Dashboard" caption in the content area. Intended as a
 * stub until the supplier-specific dashboard widgets are built.
 */
const SupplierDashboard = (props) => {
  const [sidebarExpanded, setSidebarExpanded] = useState(true);

  return (
    <div
      className="d-flex flex-row mainclass"
      style={{ height: "100vh", overflow: "auto" }}
    >
      <div
        style={{
          flex: sidebarExpanded ? "0 0 21%" : "0 0 60px",
          position: "sticky",
          top: 0,
          zIndex: 999,
        }}
      >
        <Sidebar
          dataFromParent={props.location?.pathname}
          onSidebarToggle={setSidebarExpanded}
        />
      </div>

      <div style={{ flex: 1, transition: "all 0.3s ease" }}>
        <div style={{ position: "sticky", top: 0, zIndex: 999 }}>
          <Header />
        </div>

        <div
          className="main_wrapper"
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "calc(100vh - 70px)",
          }}
        >
          <h2
            style={{
              fontFamily: "var(--font-sans)",
              color: "var(--ink-3)",
              letterSpacing: "0.02em",
              margin: 0,
            }}
          >
            Supplier Dashboard
          </h2>
        </div>
      </div>
    </div>
  );
};

export default SupplierDashboard;
